<script lang="ts" setup>
defineProps({
  navigation: {
    required: true,
    type: Array as PropType<LayoutHeaderNavigationGroups>,
  },
})

const { routeNameWithoutLocale } = useNavigation()
const route = useRoute()
</script>

<template>
  <ClientOnly>
    <Teleport to="#subnav-teleport-target">
      <div class="flex size-full items-center">
        <div
          class="flex flex-1 items-center justify-start gap-1 overflow-x-auto"
          :class="{ 'mr-2': $slots.right }"
        >
          <template
            v-for="(group, groupIndex) of navigation"
            :key="groupIndex"
          >
            <span
              v-for="item of group"
              :key="item.label"
              class="relative"
            >
              <UButton
                class="hover:!gradient-texture transition-base group/subnav-link whitespace-nowrap !no-underline"
                :color="item.color || 'gray'"
                :icon="item.icon"
                :label="item.label"
                :size="item.size"
                :to="item.to"
                :ui="{
                  base: item.active || (item.active !== false && (String(item.to).split('?')[0] === route.path.split('?')[0] || item.id === routeNameWithoutLocale)) ? 'gradient-texture !text-black dark:!text-white' : 'bg-transparent dark:text-gray-400 text-gray-600 hover:!text-black dark:hover:!text-white',
                  icon: {
                    base: item.active || (item.active !== false && (String(item.to).split('?')[0] === route.path.split('?')[0] || item.id === routeNameWithoutLocale)) ? 'text-indigo-400 dark:text-indigo-500' : 'group-hover/subnav-link:text-indigo-400 dark:group-hover/subnav-link:text-indigo-500',
                  },
                }"
                variant="link"
                @click="item?.onClick"
              >
                <template
                  v-if="item.chip"
                  #trailing
                >
                  <UChip
                    class="ml-2 mr-1 [&>*]:!text-white"
                    color="red"
                    size="xl"
                    :text="item.chip > 9 ? '9+' : item.chip"
                  />
                </template>
              </UButton>
            </span>

            <BaseVerticalDivider
              v-if="groupIndex < navigation.length - 1"
              class="mx-2 h-6"
            />
          </template>
        </div>

        <slot name="right" />
      </div>
    </Teleport>
  </ClientOnly>
</template>
